type Entries<T extends object> = { [K in keyof T]: [K, T[K]] }[keyof T];

export function reverseEnum<E extends Record<keyof E, string | number>>(e: E): { [K in E[keyof E]]: Extract<Entries<E>, [any, K]>[0] };
export function reverseEnum(e: Record<string | number, string | number>): Record<string | number, string | number> {
    const ret: Record<string | number, string | number> = {};
    Object.keys(e)
        .forEach((k) => (ret[e[k]] = k));

    return ret;
}

export function twoWayEnum<E extends Record<keyof E, string | number>>(e: E) {
    return Object.assign(reverseEnum(e), e);
}
